module.exports = __webpack_public_path__ + "media/water_front.74ccaf88.svg";